/** Allow-list event-sourced URLs to https only (prevents javascript:/data: XSS). */
export function sanitizeUrl(raw: string | undefined | null): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'https:') return null;
    return url.toString();
  } catch {
    return null;
  }
}

/** Allow-list image URLs: https only, plus data: images and blob: object URLs. */
export function sanitizeImageUrl(raw: string | undefined | null): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('blob:')) return trimmed;
  if (/^data:image\/(png|jpeg|gif|webp);base64,/.test(trimmed)) return trimmed;
  return sanitizeUrl(trimmed);
}
